export const recaptchaConfig = {
	size: 'normal',
	render: 'explicit',
	key: process.env.GATSBY_RECAPTCHA_PUBLIC_KEY,
};
export const recaptchaFunctionName = 'recaptchaCallback';
